import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'
import throttle from 'lodash/throttle'

import {
  loadAreasByLocation,
  searchAreasByLocation,
  setCurrentSearch,
  resetCurrentFilter
} from '../../actions/areas'

import { getAreasBySearch } from '../../selectors/area-selectors'

import SingleAreaSelect from '../../components/forms/single-area-select'

function mapStateToProps(state, ownProps) {
  const areas = getAreasBySearch(state, ownProps)

  const options = areas.map(area => {
    const issuesText = area.issueCount > 0 ? ` - ${area.issueCount} issue(s)` : ''

    return {
      value: area.id,
      label: `${area.name}${issuesText}`
    }
  })

  options.unshift({
    value: null,
    label: 'None'
  })

  return { options }
}

function mapDispatchToProps(dispatch, ownProps) {
  const locationId = ownProps.locationId
  let params = {
    locationId: locationId,
    searchQuery: '',
    nextPage: false
  }

  dispatch(searchAreasByLocation(params))

  const throttledSearch = throttle(
    () => dispatch(
      searchAreasByLocation(params)
    ), 250
  )

  return {
    onMenuScrollToBottom() {
      dispatch(searchAreasByLocation({
        ...params,
        nextPage: true
      }))
    },

    onInputChange(search) {
      params.searchQuery = search

      dispatch(setCurrentSearch(search))
        .then(() => throttledSearch())
    },

    resetSearch() {
      dispatch(setCurrentSearch(''))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleAreaSelect)



// WEBPACK FOOTER //
// ./src/containers/forms/single-area-select-container.js